import React from 'react'
import classnames from 'classnames/bind'
import { Icon } from '@adc/ui-core'
import styles from './styles.scss'

const cx = classnames.bind(styles)

/**
 * Actions that serve in function the same as a button, some sort of trigger to take an action. A common
 * pattern we employ is to render these inline alongside larger selection components.
 */
const ActionIcon = ({ size = 'large', ...rest }) => (
  <div
    className={cx('action-icon-container', `action-icon-container-${size}`)}
    disabled={rest.disabled}
  >
    <div className={cx('action-icon-animation-helper')} />
    <Icon {...rest} className={cx('action-icon', `action-icon-${size}`)} />
  </div>
)

ActionIcon.propTypes = Icon.propTypes

export default ActionIcon
